import React, { useState } from "react";
import './../assets/style/patientdetails.css';
import logo from '../assets/images/logo.png';
import SimpleCaptcha from './../components/captcha'; 

const PatientDetailsInput = () => {   

    return (
        <div className="container-fluid">
            <div className="card-center-wrapper">
                <div className="card-center">
                    <div className="row align-items-center justify-content-center">
                        <div className="col-10 col-sm-8 col-md-4 col-lg-3">
                            <div className="card border-0 my-3">
                                <div className="card-body">
                                    <div className="text-center mb-3 mt-5">
                                        <img className="search-logo" alt="" src={logo} />
                                    </div>
                                    <h2 className="smart-title text-center mb-5">Smart Report</h2>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PatientDetailsInput;
